import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Column } from "primereact/column";
import Spinner from "../../components/spinner";
import { axiosApi } from "../../../services/axios_api";
import PaginatorComponent from "../../components/paginator";
import useDebounce from "../../components/hooks/useDebounce";
import { toast } from "react-toastify";
import { Tag } from "primereact/tag";
import moment from "moment";
import { exportToExcel, formatNumber, renderTextWithTooltip } from "../../components/helper";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import Dots from "../../../../assets/assests/detail.png";
import Details from "./details-service";

export default function ServiceModeScreen({}) {
  const [loading, setLoading] = useState(false);
  const [filteredList, setFilteredList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [fromDate, setFromDate] = useState(moment().startOf("month").toDate());
  const [toDate, setToDate] = useState(moment().endOf("month").toDate());
  const [globalFilter, setGlobalFilter] = useState("");
  const [rowselect, setRowselect] = useState(null);
  
    const [showdetail, setShowdetail] = useState(false);
  const debouncedSearch = useDebounce(globalFilter, 500);

  const getServiceModeData = async (pageNumber = 1, pageSize = rows) => {
    setLoading(true);
    try {
      const response = await axiosApi.get(
        `/Portal/kiosks/service-mode/get-all-paginated`,
        {
          params: {
            pageNumber,
            pageSize,
            searchTerm: debouncedSearch || "",
            fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : null,
            toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : null,
          },
        }
      );
      setFilteredList(response.data.body);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      toast.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (event) => {
    const { first, rows } = event;
    setFirst(first);
    setRows(rows);
    const pageNumber = first / rows + 1;
    getServiceModeData(pageNumber, rows);
  };

  useEffect(() => {
    if (debouncedSearch) {
      getServiceModeData(1, rows, debouncedSearch);
    } else {
      getServiceModeData(1, rows);
    }
  }, [debouncedSearch, fromDate, toDate]);
  const actionTemplate = (rowData) => {
    const isActive = rowData?.isActive;
    return (
      <div className="action-buttons">
       
       
        <Button className="p-button-edit p-0 mr-3" onClick={() => showDetails(rowData)}>
          <img src={Dots} alt="Details" />
        </Button>

      </div>
    );
  };
  const showDetails = (rowData) => {
    setRowselect(rowData);
    setShowdetail(true);
  }

  const columnsData = [
    // {
    //   field: "kioskId",
    //   header: "Kiosk Id",
    //   body: (rowData) => rowData.kioskId || "--",
    //   frozen: true,
    // },
    {
      field: "kioskName",
      header: "Kiosk Name",
      body: (rowData) => renderTextWithTooltip(rowData, "kioskName", "bottom"),
    },
    {
      field: "userName",
      header: "User Name",
      body: (rowData) => rowData.userName || "--",
    },
    // {
    //   field: "cashAcceptorAmount",
    //   header: "Cash Acceptor AMT",
    //   body: (rowData) => formatNumber(rowData.cashAcceptorAmount),
    // },
    {
      field: "cashAcceptorCollect",
      header: "Cash Acceptor Coll.",
      body: (rowData) => formatNumber(rowData.cashAcceptorCollect),
    },
    {
      field: "cashAcceptorRemaining",
      header: "Cash Acceptor Rmng.",
      body: (rowData) => formatNumber(rowData.cashAcceptorRemaining),
    },
    {
      field: "cardsAvailable",
      header: "Cards Available",
      body: (rowData) => rowData.cardsAvailable || "--",
    },
    {
      field: "cardsInserted",
      header: "Cards Inserted",
      body: (rowData) => rowData.cardsInserted || "--",
    },
   
    {
      field: "receiptsPrinterStatus",
      header: "Receipts Printer Status",
      body: ({ receiptsPrinterStatus }) => (
        <Tag className={receiptsPrinterStatus === "Empty" ? "custom-danger-tag" : "custom-success-tag"} value={receiptsPrinterStatus || "--"} />
      ),
    },
    {
      field: "receiptsRollInserted",
      header: "Receipts Roll Inserted",
      body: (rowData) => (
        <Tag
          value={rowData.receiptsRollInserted ? "Yes" : "No"}
          className="custom-tag-toll"
        />
      ),
    },
    {
      field: "lastUpdated",
      header: "Date",
      body: (rowData) =>
        rowData.lastUpdated
          ? new Date(rowData.lastUpdated).toLocaleString()
          : "--",
    },
    {
      header: "Action",
      body: actionTemplate,
    },
  ];

  const exportCSV = async () => {
    setLoading(true);
    try {
      const response = await axiosApi.get(
        `/Portal/kiosks/service-mode/get-all`
      );
      exportToExcel(response.data.body, columnsData, "ServiceModeData");
    } catch (error) {
      toast.error("Failed to export data.");
      console.error("Export Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
     <Dialog
        visible={showdetail}
        onHide={() => setShowdetail(false)}
        header="Service Mode Details"
       className="dialog-size"
      >
        <Details
                  rowData={ rowselect } />
      </Dialog>
      <div className="grid align-items-center mb-3 p-2 justify-content-between gap-3">
        <div>
          <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              className="mbl_view"
              placeholder="Search"
              value={globalFilter}
              onChange={(e) => setGlobalFilter(e.target.value)}
            />
          </span>
        </div>
        <div className="grid gap-3">
          <Calendar
            placeholder="Select From Date"
            showIcon
            value={fromDate}
            onChange={(e) => setFromDate(e.value)}
            maxDate={toDate}
          />
          <Calendar
            placeholder="Select To Date"
            showIcon
            value={toDate}
            onChange={(e) => setToDate(e.value)}
            minDate={fromDate}
          />
          <Button
            className="custom-btn export-excel secondary-button"
            label="Export Excel"
            icon="pi pi-window-maximize"
            onClick={exportCSV}
          />
        </div>
      </div>

      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}

      <div className="card card-container">
        <DataTable
          emptyMessage="No record found."
          value={filteredList}
          className="custom-data-table"
          scrollable
          globalFilter={globalFilter}
        >
          {columnsData.map((data, index) => (
            <Column
              key={index}
              field={data.field}
              header={data.header}
              body={data.body}
              frozen={data.frozen}
            />
          ))}
        </DataTable>
        {totalRecords > 0 && (
          <PaginatorComponent
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </>
  );
}
